import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import Label from "./label";
export var CheckboxGroup = function CheckboxGroup(_ref) {
  var label = _ref.label,
      name = _ref.name,
      required = _ref.required,
      onChange = _ref.onChange,
      checked = _ref.checked,
      className = _ref.className,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["label", "name", "required", "onChange", "checked", "className", "style"]);

  var id = name.replace(/[\W]/g, "");
  return (
    /*#__PURE__*/
    React.createElement(Aligner, {
      className: className,
      style: style
    },
    /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      id: id,
      name: name,
      checked: checked,
      onChange: onChange
    }, rest)),
    /*#__PURE__*/
    React.createElement(Label, {
      htmlFor: id,
      $required: required
    }, label))
  );
};
CheckboxGroup.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
}; // Sauce: https://developer.mozilla.org/en-US/docs/Learn/HTML/Forms/Advanced_styling_for_HTML_forms#Checkboxes_and_radio_buttons
// and https://scottaohara.github.io/a11y_styled_form_controls/src/checkbox/

export var Checkbox =
/*#__PURE__*/
styled.input.attrs({
  type: "checkbox"
}).withConfig({
  displayName: "Checkbox"
})(["position:relative;width:24px;height:24px;appearance:none;border:2px solid #757575;border-radius:6px;margin:0;padding:0;background-color:#fff;&::-ms-check{border:2px solid #757575;border-radius:6px;background-color:#fff;}&:active{background-color:#edeeef;}&:checked{background-color:#0a146e;border-color:#0a146e;}&:checked::before{position:absolute;content:\"\";width:8px;height:12px;border-bottom:3px solid #fff;border-right:3px solid #fff;bottom:6px;right:6px;transform:rotate(45deg);}&:disabled{opacity:0.38;}"]);
var Aligner =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Aligner"
})(["display:flex;align-items:center;& ", "{flex-shrink:0;margin-right:8px;}"], Checkbox);